import useAlertService from '@/services/alerts/useAlertService.ts'
import AlertTile from '@/services/alerts/components/AlertTile'

const AlertsService = () => {
  const { alertData, active, setActive } = useAlertService()

  if (!active) return null

  const handleCancel = () => {
    setActive(false)
  }

  return <AlertTile {...alertData} onCancel={handleCancel} />
}

export default AlertsService
